import { isEmpty } from "../../../../utils/utils";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

export default function SummaryRow({ index, benchmark }) {
  const { t } = useTranslation();

  if (
    benchmark === undefined ||
    benchmark === "" ||
    index === undefined ||
    index === "" ||
    isEmpty(index) ||
    isEmpty(benchmark)
  ) {
    return null;
  }

  return (
    <tr className="family-table-row family-table-row-summary">
      <td className="family-table-summary" style={{padding: '5px'}}>
        <b>{t("SummaryRow.excess_return")}</b>
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {((index["1_day"] - benchmark["1_day"]) * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {(
          (index.beginning_of_year - benchmark.beginning_of_year) *
          100
        ).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {((index["1y"] - benchmark["1y"]) * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {((index["3y"] - benchmark["3y"]) * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {((index["5y"] - benchmark["5y"]) * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {((index["10y"] - benchmark["10y"]) * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell family-table-cell-bold">
        {((index["15y"] - benchmark["15y"]) * 100).toFixed(2)}
      </td>
    </tr>
  );
}

SummaryRow.propTypes = {
  index: PropTypes.object.isRequired,
  benchmark: PropTypes.object.isRequired,
};
